module.exports = __webpack_public_path__ + "static/media/6.e16d0d99.jpg";